import { lang, commonLang } from '@umu/ukit-lang';
import { $location } from '@umu/umu-dom';
import share1 from './images/share1.png';
import share2 from './images/share2.png';
import share3 from './images/share3.png';
import share4 from './images/share4.png';
import share5 from './images/share5.png';
import share6 from './images/share6.png';
import share16 from './images/share16.png';
import share8 from './images/share8.png';
import share9 from './images/share9.png';
import share10 from './images/share10.png';
import shareLogo from './images/shareLogo.png';

import { config } from 'common';
const { SESSION_TYPES } = config;

const { REGISTRATION, SURVEY, ASK, DISCUSSION, PHOTO, GAME, ATTENDANCE, HOMEWORK, RAFFLE_DRAWING, QUIZ } =
    SESSION_TYPES;

export const IconMap = {
    [REGISTRATION]: share9, // 报名页
    [SURVEY]: share1, // 问卷, 问卷结果页
    [ASK]: share2, // 提问
    [DISCUSSION]: share3, // 讨论
    [PHOTO]: share4, // 拍照
    [GAME]: share5, // 游戏
    [ATTENDANCE]: share6, // 签到
    [HOMEWORK]: share16, // 作业
    [RAFFLE_DRAWING]: share8, // 抽奖
    [QUIZ]: share10, // 考试, 考试结果页, 考试排行榜页
};

export function getShareIcon(type?: number) {
    let imgUrl = shareLogo;
    if (!!type) {
        imgUrl = IconMap[type];
    }

    if (!/^http/i.test(imgUrl)) {
        imgUrl = $location.protocol + '//' + $location.hostname + imgUrl;
    }
    return imgUrl;
}

export interface IGetDefaultSessionTitleParam {
    sessionTitle: string;
    courseTitle: string;
}

export function getDefaultSessionTitle(params: IGetDefaultSessionTitleParam) {
    const titleContent = params.sessionTitle + ' - ' + params.courseTitle;
    let title = commonLang('UMU 互动学习平台');
    if (params.sessionTitle) {
        title = lang('{$0}请你参与', titleContent);
    }
    return title;
}

export interface IGetDefaultSessionDescParam {
    sessionTitle: string;
    creatorName: string;
}

export function getDefaultSessionDesc(params: IGetDefaultSessionDescParam) {
    let desc = lang(
        '用手机随时组织互动与微课，用大屏幕同步展示学习结果，让互联网升级线上线下课堂，让每个人融入、分享、收获。',
    );
    if (params.sessionTitle) {
        desc = lang('{$0}邀请你加入{$1}线上互动，一起通过UMU分享与收获吧', params.creatorName, params.sessionTitle);
    }

    return desc;
}
